<template>
    <div>
        <span class="form__validation" v-if="required(validate)">
          {{ L.localize('Validation_Required') }}
        </span>

        <span class="form__validation" v-if="checkSameAs(validate)">
          {{ L.localize('Validation_Compare') }}
        </span>

        <template v-if="validation[model]">
            <span class="form__validation" v-for="error in validation[model].messages">{{ error }}</span>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import L from 'services/Localization'

export default {
  name: 'validation',
  data() {
    return {
      L: L
    }
  },
  props: ['model', 'validate'],
  computed: {
    ...mapGetters({
      validation: 'getValidation'
    })
  },
  methods: {
    required(validate) {
      if (validate.required === undefined) return false
      return validate.$error && !validate.required
    },
    checkSameAs(validate) {
      if (validate.sameAs === undefined) return false
      return validate.$error && !validate.sameAs
    }
  }
}
</script>



// WEBPACK FOOTER //
// Validation.vue?3ff8c86c